export async function fetchMessages(phraseProject: string, locale: string) {
    const url = `/searchdiscover/i18n/vertical/${phraseProject}/locale/${locale}`;
    const response = await fetch(url); //using fetch directly, as the only other option would be Qwest in this project
    const data = await response.json();
    return data?.at(0)?.translations;
}

export async function getFallbackMessages(lang: string, phraseProject: string) {
    switch (lang) {
        case "bg-BG":
            return await import("./translations/" + phraseProject + "/bg-BG.json").then((imported) => imported.default);
        case "cs-CZ":
            return await import("./translations/" + phraseProject + "/cs-CZ.json").then((imported) => imported.default);
        case "de-DE":
            return await import("./translations/" + phraseProject + "/de-DE.json").then((imported) => imported.default);
        case "en-PK":
            return await import("./translations/" + phraseProject + "/en-PK.json").then((imported) => imported.default);
        case "es-ES":
            return await import("./translations/" + phraseProject + "/es-ES.json").then((imported) => imported.default);
        case "fr-FR":
            return await import("./translations/" + phraseProject + "/fr-FR.json").then((imported) => imported.default);
        case "hr-HR":
            return await import("./translations/" + phraseProject + "/hr-HR.json").then((imported) => imported.default);
        case "hu-HU":
            return await import("./translations/" + phraseProject + "/hu-HU.json").then((imported) => imported.default);
        case "it-IT":
            return await import("./translations/" + phraseProject + "/it-IT.json").then((imported) => imported.default);
        case "nl-NL":
            return await import("./translations/" + phraseProject + "/nl-NL.json").then((imported) => imported.default);
        case "pl-PL":
            return await import("./translations/" + phraseProject + "/pl-PL.json").then((imported) => imported.default);
        case "pt-PT":
            return await import("./translations/" + phraseProject + "/pt-PT.json").then((imported) => imported.default);
        case "ro-MD":
            return await import("./translations/" + phraseProject + "/ro-MD.json").then((imported) => imported.default);
        case "ro-RO":
            return await import("./translations/" + phraseProject + "/ro-RO.json").then((imported) => imported.default);
        case "ru-KZ":
            return await import("./translations/" + phraseProject + "/ru-KZ.json").then((imported) => imported.default);
        case "ru-RU":
            return await import("./translations/" + phraseProject + "/ru-RU.json").then((imported) => imported.default);
        case "sk-SK":
            return await import("./translations/" + phraseProject + "/en-US.json").then((imported) => imported.default);
        case "sr-RS":
            return await import("./translations/" + phraseProject + "/sr-RS.json").then((imported) => imported.default);
        case "tr-TR":
            return await import("./translations/" + phraseProject + "/tr-TR.json").then((imported) => imported.default);
        case "uk-UA":
            return await import("./translations/" + phraseProject + "/uk-UA.json").then((imported) => imported.default);
        default:
            return await import("./translations/" + phraseProject + "/en-US.json").then((imported) => imported.default);
    }
}
